import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Popped.module.css";
import { FaTimes } from "react-icons/fa";
import PrivacyPolicy from "../privacy/Privacy";

const Popped = ({ onClose, title }) => {
  const [agreed, setAgreed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const nameRef = useRef(null);
  const phoneRef = useRef(null);

  const reciver = "Kerenaxelrod@gmail.com";
  const serverUrl =
    "https://dynamic-server-dfc88e1f1c54.herokuapp.com/leads/newLead";
  const webhookUrl =
    "https://hook.us1.make.com/btghlzqtwm5c0hw1xali1h2h973ii1pd";

  const sendToWebhook = async (data) => {
    try {
      const response = await fetch(webhookUrl, {
        method: "POST",
        body: new URLSearchParams(data),
      });
      console.log("Webhook sent successfully", response.status);
    } catch (err) {
      console.error("Webhook error:", err);
    }
  };

  const handleClose = () => {
    if (onClose) onClose();
  };

  const handlePrivacyClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (!agreed) {
      alert("עליך לאשר את תנאי השימוש ומדיניות הפרטיות");
      return;
    }

    const name = nameRef.current.value;
    const phone = phoneRef.current.value;

    if (!name || !phone) {
      alert("אנא מלא את כל השדות");
      return;
    }

    setIsSubmitting(true);

    const serverData = {
      name,
      phone,
      email: "",
      reason: "משרד",
      reciver,
    };

    const webhookData = {
      name,
      phone,
      email: "",
      source: "hamisrad.co.il",
      timestamp: new Date().toISOString(),
    };

    sendToWebhook(webhookData);

    try {
      const serverResponse = await fetch(serverUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(serverData),
      });

      if (!serverResponse.ok) {
        throw new Error("submit failed");
      }

      setIsSubmitting(false);

      // מעבר לדף תודה
      navigate('/תודה');

    } catch (err) {
      console.error(err);
      alert("התרחשה שגיאה, נסה שוב מאוחר יותר");
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.popped}>
        <FaTimes className={styles.closeIcon} onClick={handleClose} />

        <div className={styles.container}>
          <div className={styles.subtitle}></div>
          <div className={styles.title}>זמן לקחת החלטה</div>
        </div>

        <div className={styles.formContainer}>
          <form className={styles.form} onSubmit={submitHandler}>
            <div className={styles.inputGroup}>
              <input
                type="text"
                className={styles.input}
                placeholder="שם מלא"
                ref={nameRef}
                required
                disabled={isSubmitting}
              />

              <input
                type="tel"
                className={styles.input}
                placeholder="טלפון"
                ref={phoneRef}
                required
                disabled={isSubmitting}
              />

              <div className={styles.checkboxContainer}>
                <label className={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    checked={agreed}
                    onChange={() => setAgreed(!agreed)}
                    className={styles.checkbox}
                    disabled={isSubmitting}
                  />
                  קראתי את
                  <span onClick={handlePrivacyClick}>
                    <PrivacyPolicy
                      ownerName="קרן אקסלרוד - המשרד"
                      email="Kerenaxelrod@gmail.com"
                      phone="+972 50-891-9747"
                      domain="https://hamisrad.co.il/"
                    />
                  </span>
                  ואני מאשר
                </label>
              </div>

              <button
                type="submit"
                className={`${styles.button} ${
                  isSubmitting ? styles.buttonDisabled : ""
                }`}
                disabled={isSubmitting}
              >
                {isSubmitting ? "שולח..." : "קרן, צרי איתי קשר"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Popped;